// import * as React from "react";
// import TableContainer from "@mui/material/TableContainer";
// import { useState } from "react";
// import Box from "@mui/material/Box";
// import { DataGrid } from "@mui/x-data-grid";
// import "primeflex/primeflex.css";
// import {
//     gridPageCountSelector,
//     gridPageSelector,
//     useGridApiContext,
//     useGridSelector,
//     GridToolbarContainer,
//     GridToolbarQuickFilter,
//     GridToolbarColumnsButton,
//     GridToolbarFilterButton,
// } from "@mui/x-data-grid";
// import Pagination from "@mui/material/Pagination";
// import { memo } from "react";

import {
  React,
  DataGrid,
  TableContainer,
  Pagination,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
  GridToolbarContainer,
  GridToolbarQuickFilter,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  memo,
  useState,
  Box,
} from "../../../Libraries/Screens/index";

function CustomToolbar() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
      </GridToolbarContainer>
      <GridToolbarQuickFilter />
    </Box>
  );
}

const PingHistoryLogs = (props) => {
  const [pageSize, setPageSize] = useState(5);
  function CustomPagination() {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <Pagination
        color="primary"
        sx={{ mt: 3 }}
        count={pageCount}
        page={page + 1}
        onChange={(event, value) => apiRef.current.setPage(value - 1)}
      />
    );
  }

  const columns = [
    { field: "ser_ping_id", headerName: "PING ID", width: 100 },
    { field: "ser_customer_id", headerName: "CUSTOMER ID", width: 130 },
    { field: "ser_screen_id", headerName: "SCREEN ID", width: 130 },
    { field: "txt_ping_status", headerName: "PING STATUS", width: 130 },
    {
      field: "txt_ping_description",
      headerName: "PING DESCRIPTION",
      width: 170,
    },
    {
      field: "application_version",
      headerName: "APP VERSION",
      width: 150,
    },
    { field: "dte_created_date", headerName: "CREATED DATE", width: 150 },
    {
      field: "txt_ip_address",
      headerName: "IP ADDRESS",
      width: 200,
    },
  ];

  return (
    <>
      <TableContainer>
        <div style={{ display: "flex", height: "100%" }}>
          <div style={{ flexGrow: 1 }}>
            <Box
              sx={{
                height: 450,
                width: "100%",
              }}
            >
              <DataGrid
                className="datagrid"
                rows={props.logs === null ? [] : props.logs}
                loading={props.logs === null ? true : false}
                columns={columns}
                getRowId={(row) => row.ser_ping_id}
                pageSize={pageSize}
                disableSelectionOnClick
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                components={{
                  Pagination: CustomPagination,
                  Toolbar: CustomToolbar,
                }}
                sx={{
                  border: "none",
                  "& .MuiDataGrid-cell:hover": {
                    color: "primary.main",
                  },
                }}
              />
            </Box>
          </div>
        </div>
      </TableContainer>
    </>
  );
};
export default memo(PingHistoryLogs);
